import '../assets/NcRadioGroup-CNgjqqiP.css';
import Vue, { defineComponent, ref, provide, computed } from "vue";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { I as INSIDE_RADIO_GROUP_KEY } from "./useNcRadioGroup-DaZbEKbf.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const __default__ = {
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  }
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "NcRadioGroup",
  props: {
    label: null,
    labelHidden: { type: Boolean },
    description: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const descriptionId = createElementId();
    const buttonVariant = ref();
    provide(INSIDE_RADIO_GROUP_KEY, computed(() => ({
      modelValue: props.modelValue,
      onUpdate,
      register
    })));
    function register(isButton) {
      if (buttonVariant.value !== void 0 && buttonVariant.value !== isButton) {
        Vue.util.warn("[NcRadioGroup] Mixing NcCheckboxRadioSwitch and NcRadioGroupButton is not possible!");
      }
      buttonVariant.value = isButton;
    }
    function onUpdate(value) {
      emit("update:modelValue", value);
    }
    return { __sfc: true, props, emit, descriptionId, buttonVariant, register, onUpdate };
  }
});
const radioGroup = "_radioGroup_u3tih_20";
const radioGroup_buttonVariant = "_radioGroup_buttonVariant_u3tih_24";
const radioGroup__label = "_radioGroup__label_u3tih_28";
const radioGroup__description = "_radioGroup__description_u3tih_34";
const radioGroup__wrapper = "_radioGroup__wrapper_u3tih_40";
const style0 = {
  "material-design-icon": "_material-design-icon_u3tih_12",
  radioGroup,
  radioGroup_buttonVariant,
  radioGroup__label,
  radioGroup__description,
  radioGroup__wrapper
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("fieldset", { class: [{
    [_vm.$style.radioGroup_buttonVariant]: _setup.buttonVariant
  }, _vm.$style.radioGroup], attrs: { "aria-describedby": _vm.description ? _setup.descriptionId : void 0 } }, [_c("legend", { class: [_vm.$style.radioGroup__label, { "hidden-visually": _vm.labelHidden }] }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm.description ? _c("p", { class: _vm.$style.radioGroup__description, attrs: { "id": _setup.descriptionId } }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e(), _c("div", { class: _vm.$style.radioGroup__wrapper }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcRadioGroup = __component__.exports;
export {
  NcRadioGroup as N
};
//# sourceMappingURL=NcRadioGroup-VKZJ0Vnh.mjs.map
